import {useEffect, useState} from "react";
import Tabletool from "./components/tableTool";
import handleChartableData from "./utilities/handleChartableData";
import Dropdown from "./components/dropdown";
import {SheetContext} from "./components/sheetContext";

function App(props) {
  const endPoint = props.endpoint
  const tabletoolId = props.id

  const [allData, setAllData] = useState();
  const [activeSheet, setActiveSheet] = useState(0);
  const [chartData, setChartData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [parsedShowCells, setParsedShowCells] = useState(0);
  const [tabletoolContainer, setTabletoolContainer] = useState();
  const [firstTr, setFirstTr] = useState();
  const [showNav, setShowNav] = useState(false);

  useEffect(() => {
    fetch(endPoint)
      .then(res => {
        return res.json()
      })
      .then(data => {
        if (data) {
          setLoader(false)
          setAllData(data)
          setTabletoolContainer(document.querySelector('#tabletool-id-'+tabletoolId + " .sheet-"+activeSheet))
          setTableData(data[0])
          setChartData(handleChartableData(data[0]))
        }
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endPoint]);

  useEffect(() => {
    // tableData.rows && setParsedShowCells(Object.values(Object.values(tableData.rows)[0].data).length - tableData.chartable_columns.length + 5)
    tableData.rows && setParsedShowCells(5)
    tabletoolContainer && setFirstTr(tabletoolContainer.querySelector("table tr:not(.not-chartable)"))
  }, [tabletoolContainer, activeSheet, tableData])

  useEffect(() => {
    setShowNav(() => {
      return !!(firstTr && tabletoolContainer && tableData.rows && firstTr.querySelectorAll("td").length > parsedShowCells + 1);
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstTr, activeSheet])

  return (
    <>
      <div id="loader" className={`${!loader?'d-none':''} p-5 text-center w-100`}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
      <div className={`sheet sheet-${activeSheet}`}>
        <SheetContext.Provider value={{allData, tabletoolId, chartData, tableData, activeSheet, setTableData, setChartData, setActiveSheet, parsedShowCells, tabletoolContainer, setTabletoolContainer, firstTr, showNav}}>
          {!loader && allData && allData.length > 1 && <Dropdown/>}
          {!loader && <Tabletool/>}
        </SheetContext.Provider>
      </div>
    </>
  );
}

export default App;
